export const green = {
  190: '#071901',
  175: '#123E02',
  150: '#247B04',
  125: '#35B805',
  100: '#47F607',
  75: '#75F845',
  50: '#A3FB83',
  25: '#D1FDC1',
  10: '#EDFEE6',
  5: '#f6fff2',
  2: '#f6fff2',
};

// export const green = {
//   190: '#0F2414',  // глубокий, насыщенный, чистый зелёный
//   175: '#184B28',
//   150: '#1F733C',
//   125: '#2F9C4E',
//   100: '#4ED85B',  // базовый, скорректированный твой исходный цвет
//   75:  '#79E588',
//   50:  '#A8F0B4',
//   25:  '#D2F8DD',
//   10:  '#ECFBF2',
//   5:   '#F6FEF9',
//   2:   '#FBFFFC',
// };

export type GreenVariants = keyof typeof green;
